import React from 'react';
import { FieldArray } from 'formik';
import { TextField } from 'components/forms';
import { H1, H2, P } from 'components/text';

const Representatives = () => {
  return (
    <>
      <H1>Authorized Representatives</H1>
      <P>
        Authorized Representatives can trade, deposit, withdraw, and add users to the account.
      </P>

      <FieldArray
        name="authorized_representatives"
        render={() => (
          <>
            <H2>Authorized Representative 1</H2>

            <TextField
              name={`entity.authorized_representatives[0].first_name`}
              label="First name"
              required
            />

            <TextField
              name={`entity.authorized_representatives[0].last_name`}
              label="Last name"
              required
            />

            <TextField
              name={`entity.authorized_representatives[0].email`}
              label="Email"
              type="email"
              required
            />

            <TextField
              name={`entity.authorized_representatives[0].phone`}
              label="Phone"
              type="tel"
              required
            />

            <hr />

            <H2>Authorized Representative 2</H2>
            <P style={{"marginTop": "-1.5rem"}}>
              (Optional but recommended)
            </P>

            <TextField
              name={`entity.authorized_representatives[1].first_name`}
              label="First name"
            />

            <TextField
              name={`entity.authorized_representatives[1].last_name`}
              label="Last name"
            />

            <TextField
              name={`entity.authorized_representatives[1].email`}
              label="Email"
              type="email"
            />

            <TextField
              name={`entity.authorized_representatives[1].phone`}
              label="Phone"
              type="tel"
            />

            <hr />
          </>
        )}
      />
    </>
  );
};

export default Representatives;
